import { extractWcErrorMessage } from "src/checkout/helpers/wooCommerceErrors"
import { recordError } from "src/utilities/errorReporting"

export const COUPON_CATEGORY_CONFLICT_ERROR = "CATEGORY_CONFLICT"

export function extractAndRecordCouponErrorMessage(code: string, error: unknown) {
  if (String(error).includes(COUPON_CATEGORY_CONFLICT_ERROR)) {
    return "Du hast bereits einen Rabattcode angewendet, der mit diesem Rabattcode nicht kombinierbar ist."
  }

  const { errorMessage, isFallback, isValidation } = extractWcErrorMessage(error)

  if (isValidation) {
    return "Ungültiger Rabattcode"
  }

  if (isFallback) {
    recordError(`Failed to add coupon code "${code}"`, error)
  }

  return errorMessage
}
